import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services';
import { TenantRisk } from 'src/app/models/tenantRisk.model';
import { TenantRiskService } from 'src/app/services/tenantRisk.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  standalone: false,
  selector: 'app-analyst-enablement',
  templateUrl: './analyst-enablement.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./analyst-enablement.component.scss']
})
export class AnalystEnablementComponent implements OnInit, OnDestroy {
  isLoading = false;
  isSaving = false;
  isEnabled = false;
  private tenantRisk: TenantRisk;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private tenantRiskService: TenantRiskService,
    private toastService: ToastService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.tenantRiskService.getCurrent().pipe(takeUntil(this.destroy$)).subscribe({
      next: (tenantRisk) => {
        this.tenantRisk = tenantRisk;
        this.isEnabled = tenantRisk.isAiAnalystEnabled;
        this.isLoading = false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.isLoading = false;
      }
    });
  }

  save(): void {
    if (!this.tenantRisk) return;
    this.isSaving = true;
    this.tenantRiskService.patch(this.tenantRisk.id, { isAiAnalystEnabled: this.isEnabled }).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.tenantRisk.isAiAnalystEnabled = this.isEnabled;
        this.authService.setCurrentUserAiAnalystEnabled(this.isEnabled);
        this.isSaving = false;
        this.toastService.showSuccess('Success', true);
      },
      error: (error) => {
        this.isEnabled = this.tenantRisk.isAiAnalystEnabled;
        this.isSaving = false;
        this.toastService.showError(error);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
